import { ReactNode } from "react";

import { CellContainer } from "./CellContainer";
import { CellActions } from "./CellActions";

export interface BaseCellProps {
  children: ReactNode;
  isSelected?: boolean;
  actions?: ReactNode;
  borderColor?: string;
  className?: string;
}

export const BaseCell = ({
  children,
  isSelected,
  actions,
  borderColor,
  className = "",
}: BaseCellProps) => (
  <>
    {actions && <CellActions>{actions}</CellActions>}
    <CellContainer isSelected={isSelected} borderColor={borderColor} className={className}>
      {children}
    </CellContainer>
  </>
);
